<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md9>
        <p class="headline mt-3">
          Flujo de canales
        </p>
      </v-flex>
      <v-flex md3 class="text-xs-right">
        <v-btn class="k-orange-linear white--text mr-0" large @click="dialog = !dialog">
          AGREGAR FLUJO DE CANAL
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md12>
        <v-text-field
          v-model="filters.search"
          label="Buscar..."
          color="black"
          solo>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-list class="mt-2 pa-0">
      <draggable v-model="workflowChannels" :options="{group:'people'}" @change="drag">
        <v-list-tile v-for="(element, i) in workflowChannels" :key="element.id" @click="" class="h-80">
          <v-layout justify-center align-center>
            <v-flex md1 class="text-xs-center">
              <v-icon class="f2em k-orange-linear-text">fas fa-draw-polygon</v-icon>
            </v-flex>
            <v-flex md9>
              <v-layout justify-center align-center>
                <v-flex md3>
                  <v-layout row wrap>
                    <v-flex md12>
                      {{element.channel.toUpperCase()}}
                    </v-flex>
                    <v-flex md12 class="k-grey-light-text">
                      Orden: {{element.sort_order}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md7>
                  <v-layout row wrap>
                    <v-flex md12>
                      Porcentaje de predicción
                    </v-flex>
                    <v-flex md12 class="k-grey-light-text">
                      {{ element.p_1.split('.')[1] }} %
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md2 class="text-xs-right">
                  <v-chip small :class="{'white--text':true, 'green':element.status === 'Activo', 'red':element.status === 'Inactivo'}">
                    <v-icon small class="white--text pr-2">{{element.status === 'Activo' ? 'fas fa-check' : 'fas fa-times'}}</v-icon>
                    {{element.status}}
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md2 class="text-xs-right">
              <v-menu offset-y>
                <v-btn class="grey--text" icon small slot="activator">
                  <v-icon small>fas fa-ellipsis-v</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="changeStatus(element.id, element.status === 'Activo' ? 'Inactivo' : 'Activo')">
                    <v-list-tile-title>{{element.status === 'Activo' ? 'Desactivar' : 'Activar'}}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="editItem(element.id)">
                    <v-list-tile-title>Editar</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="deleteItem(element.id, `${element.channel} #${element.sort_order}`)">
                    <v-list-tile-title>Eliminar</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </draggable>
    </v-list>
    <save-dialog
      :title="title"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="form.channel"
              v-validate="'required'"
              data-vv-name="channel"
              data-vv-as="canal"
              :error-messages="errors.collect('channel')"
              :items="channels"
              label="Canal"
              color="black">
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.p_1"
              v-validate="'required|decimal'"
              data-vv-name="p_1"
              data-vv-as="porcentaje"
              :error-messages="errors.collect('p_1')"
              color="black"
              label="Porcentaje">
            </v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="workflow_channels"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
  </v-container>
</template>

<script>
import EventBus from '@/event-bus';
import draggable from 'vuedraggable';
import dataTableListMixin from '@/mixins/dataTableList';
import saveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import deleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import formatDateMixin from '@/mixins/formatDate';

const _ = require('lodash');

export default {
  components: {
    'save-dialog': saveDialog,
    'delete-dialog': deleteDialog,
    draggable,
  },
  mixins: [
    saveDialogMixin,
    formatDateMixin,
    deleteDialogMixin,
    dataTableListMixin,
  ],
  created() {
    EventBus.$on('update', () => {
      this.getWorkflowChannels();
    });
    this.getWorkflowChannels();
  },
  data() {
    return {
      workflowChannels: [],
      route: 'workflow_channels',
      showName: 'flujo de canal',
      filters: {
        search: '',
      },
      channels: [
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Sms',
          value: 'sms',
        },
        {
          text: 'Ivr',
          value: 'ivr',
        },
      ],
      form: {
        channel: '',
        p_1: '',
      },
    };
  },
  methods: {
    drag(e) {
      // eslint-disable-next-line
      this.workflowChannels[e.moved.oldIndex].sort_order > this.workflowChannels[e.moved.newIndex].sort_order ? this.changeOrder(e.moved.element.id, '+') : this.changeOrder(e.moved.element.id, '-');
    },
    editItem(id) {
      EventBus.$emit('editItem', id);
    },
    getWorkflowChannels() {
      this.axios.get(`workflow_channels?paginate=0${this.filters.search ? `&search=${this.filters.search}` : ''}`).then((response) => {
        this.workflowChannels = response.data;
      });
    },
    changeOrder(id, operator) {
      this.axios.patch(`workflow_channels/${id}`, {
        operator,
      }).then(() => {
        this.getWorkflowChannels();
      }).catch((e) => {
        EventBus.$emit('modal', e.response.data);
      });
    },
    changeStatus(id, status) {
      this.axios.patch(`workflow_channels/${id}`, {
        status,
      }).then(() => {
        this.getWorkflowChannels();
      }).catch(() => { });
    },
    /* eslint-disable */
    searchData: _.debounce(function() { this.getWorkflowChannels(); }, 500),
  },
  watch: {
    filters: {
      handler(val) {
        if (val.search === '') {
          this.getWorkflowChannels();
        } else {
          this.searchData();
        }
      },
      deep:true,
    }
  },
  /* eslint-enable */
};
</script>

<style scoped>
pre {
  background: #ddd;
  height: 200px;
  white-space: normal;    /* Internet Explorer 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/workflow_channel/Index.vue